<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import "jquery";
import "bootstrap";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { childRouter } from "@/router/childRouter";
export default {
  name: "App",
  computed: {
    ...mapGetters({
      loginData: "getlogin/get_loginData",
      selectPage: "getlogin/get_selectPage",
      selectPageName: "getlogin/get_selectPageName",
      pageName: "getlogin/get_pageName",
      pageAccess: "getlogin/get_pageAccess"
    })
  },
  methods: {
    ...mapActions({
      change_loginData: "getlogin/change_loginData",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_pageName: "getlogin/set_pageName",
      change_pageAccess: "getlogin/change_pageAccess"
    }),
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2)
        return parts
          .pop()
          .split(";")
          .shift();
    }
  },
  created: function() {
    console.log(sessionStorage.getItem("loginStatus"));
    let vm = this;
    vm.set_pageName();
    console.log(vm.$router.currentRoute.path);
    if (vm.$router.currentRoute.path != "/login") {
      //===========================測試SSO用===========================//
      // let testSSO = vm.getCookie("sso");
      // console.log(testSSO);
      // if (testSSO == undefined) {
      //   window.location.replace("https://192.168.39.73:8885/KingMaker");
      // }

      //在頁面載入時讀取sessionStorage裡的狀態資訊並更新vuex資料，更新完成後remove sessionStorage
      if (
        sessionStorage.getItem("loginStatus") != null &&
        sessionStorage.getItem("loginStatus") != "undefined"
      ) {
        var obj = {};
        obj.account = sessionStorage.getItem("loginAccount");
        obj.status = Boolean(sessionStorage.getItem("loginStatus"));
        obj.username = sessionStorage.getItem("loginUsername");
        obj.accessList = JSON.parse(sessionStorage.getItem("loginAccessList"));
        var access = JSON.parse(sessionStorage.getItem("loginAccessList"));
        var page_access = JSON.parse(sessionStorage.getItem("pageAccess"));
        vm.change_loginData(obj);
        var selectPage = sessionStorage.getItem("selectPage");
        vm.change_selectPage(selectPage);
        var selectPageName = sessionStorage.getItem("selectPageName");
        vm.change_selectPageName(selectPageName);
        if (
          access == "ofco_pc" ||
          access == "ofco_demo" ||
          access == "general" ||
          access == "manager" ||
          access == "admin"
        ) {
          // let trueList_ofco = Object.keys(page_access).filter(
          //   (acc) => page_access[acc]
          // );
          // if (!trueList_ofco.includes("home")) {
          //   trueList_ofco.push("home");
          // }
          // childRouter[0].children = childRouter[0].children.filter((item) =>
          //   trueList_ofco.includes(item.path)
          // );
          vm.change_pageAccess(page_access);
        } else if (access != "ALL") {
          const trueList = Object.keys(access).filter(acc => access[acc]);
          trueList.push("home");
          childRouter[0].children = childRouter[0].children.filter(item =>
            trueList.includes(item.path)
          );
        } else {
          // var obj2 = {};
          // //Deep copy
          // var pageAccessobj = Object.assign({}, vm.pageAccess);
          // Object.keys(pageAccessobj).forEach(function (key) {
          //   obj2[key] = true;
          // });
          vm.change_pageAccess(page_access);
        }
        console.log(childRouter);
        vm.$router.addRoutes(childRouter);
        sessionStorage.removeItem("loginStatus");
        sessionStorage.removeItem("loginUsername");
        sessionStorage.removeItem("loginAccount");
        sessionStorage.removeItem("loginAccessList");
        sessionStorage.removeItem("selectPage");
        sessionStorage.removeItem("selectPageName");
        sessionStorage.removeItem("pageAccess");
      } else {
        vm.$router.push("/login");
        // window.location.replace("https://192.168.39.73:8885/KingMaker");
      }
    }
    //  else {
    //   //===========================測試SSO用===========================//
    //   const getParams = () => {
    //     const query = location.search.slice(1);
    //     return query.split("&").reduce((param, q) => {
    //       const [k, v] = q.split("=");
    //       param[k] = v;
    //       return param;
    //     }, {});
    //   };
    //   const checkParams = () => {
    //     const params = getParams();
    //     if (params["sso"]) {
    //       var expires = new Date();
    //       //有效時間保存 6 小時 6*60*60*1000
    //       expires.setTime(expires.getTime() + 21600000);
    //       document.cookie =
    //         "sso=" + params["sso"] + ";expires=" + expires.toGMTString();
    //       window.history.replaceState({}, document.title, "/");

    //       var obj = {};
    //       obj.account = "iottester";
    //       obj.status = true;
    //       obj.username = "iottester";
    //       obj.accessList = "ALL";
    //       vm.change_loginData(obj);
    //       var obj2 = {};
    //       var pageAccessobj = Object.assign({}, vm.pageAccess);
    //       Object.keys(pageAccessobj).forEach(function(key) {
    //         obj2[key] = true;
    //       });
    //       vm.change_pageAccess(obj2);
    //       vm.change_selectPage("elecboard");
    //       vm.change_selectPageName(vm.pageName.elecboard);
    //       vm.$router.addRoutes(childRouter);
    //       vm.$router.push("/index");
    //     } else {
    //       window.location.replace("https://192.168.39.73:8885/KingMaker");
    //     }
    //   };
    //   checkParams();
    // }

    // console.log(vm.loginData);
    // console.log(vm.loginData.status);
    //在頁面重新整理時將vuex裡的資訊儲存到localStorage裡
    window.addEventListener("beforeunload", () => {
      if (vm.loginData.status === true) {
        sessionStorage.setItem("loginStatus", Boolean(vm.loginData.status));
        sessionStorage.setItem("loginUsername", vm.loginData.username);
        sessionStorage.setItem("loginAccount", vm.loginData.account);
        sessionStorage.setItem("selectPage", vm.selectPage);
        sessionStorage.setItem("selectPageName", vm.selectPageName);
        sessionStorage.setItem("pageAccess", JSON.stringify(vm.pageAccess));
        sessionStorage.setItem(
          "loginAccessList",
          JSON.stringify(vm.loginData.accessList)
        );
      } else {
        var obj = {};
        obj.account = null;
        obj.status = false;
        obj.username = null;
        obj.accessList = null;
        var obj2 = {};
        //Deep copy
        var pageAccessobj = Object.assign({}, vm.pageAccess);
        Object.keys(pageAccessobj).forEach(function(key) {
          obj2[key] = false;
        });
        vm.change_pageAccess(obj2);
        vm.change_loginData(obj);
        vm.$router.push("/login");
        // window.location.replace("https://192.168.39.73:8885/KingMaker");
      }
    });
  }
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/src/index.scss";
@font-face {
  font-family: "dfyuanstd-w3";
  src: url("assets/css/dfyuanstd-w3.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "dfyuanstd-w5";
  src: url("assets/css/dfyuanstd-w5.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "dfyuanstd-w7";
  src: url("assets/css/dfyuanstd-w7.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "dfyuanstd-w8";
  src: url("assets/css/dfyuanstd-w8.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
* {
  font-family: "dfyuanstd-w7";
  outline: none; //去除點擊的藍邊框
}
.container {
  min-width: 100%;
}
th {
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue